import { Injectable } from '@angular/core';
import { UserWizardService } from '../../../services/user/user.wizard.service';
import {
  ApiService,
  InputDatastoreService,
  CountryListService,
  DialogService,
  UserService,
  ValuesExchangeProvider
} from '@nrwl/common-lib';
import { Unsubscribable } from 'rxjs';
@Injectable()
export class UserSiteSelectioniwizardService extends UserWizardService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  requestObject: any;
  selectedSites = [];
  exchangeUnsubscribe: Unsubscribable;
  userNameUnsubscribe: Unsubscribable;
  selectedUserName = '';
  userEmailNotificationPath = '/notification/v1/operations/preferences/alerts/';
  constructor(
    apiService: ApiService,
    inputDatastoreService: InputDatastoreService,
    countryListService: CountryListService,
    dialogService: DialogService,
    readonly userService: UserService,
    valuesExchange: ValuesExchangeProvider
  ) {
    super(
      apiService,
      inputDatastoreService,
      countryListService,
      dialogService,
      userService,
      valuesExchange
    );
  }
}
